<template>
<div></div>
</template>

<script>
export default {
  name: 'bm-view'
}
</script>



// WEBPACK FOOTER //
// src/components/vue-baidu-map/components/map/MapView.vue